module.exports = __webpack_public_path__ + "img/p4_4.47543ff0.webp";